
export function toggleLoad(isLoaded) {
    return dispatch => {
        dispatch({ type: 'IS_LOADED', isLoaded })
    }
}